import { ReactNode, CSSProperties, ButtonHTMLAttributes } from "react";
import { ButtonColor, ButtonSize } from "../../sharedTypes/components";
import { Link } from "../../components/Link";
import Loader from "../../components/Loader";
import { ComponentWrapperHOC } from "../../components/WrapperHoc";
import s from "./button.module.scss";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  text: string;
  color: ButtonColor;
  outlined?: boolean;
  href?: string;
  size?: ButtonSize;
  target?: "_self" | "_blank" | "_parent" | "_top";
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  loading?: boolean;
  containerStyle?: CSSProperties;
  textStyle?: CSSProperties;
  contentClassName?: string;
}

export function Button(props: Readonly<Props>) {
  const {
    text,
    color,
    loading,
    disabled,
    onClick,
    startIcon,
    endIcon,
    className,
    containerStyle,
    textStyle,
    href,
    size,
    target,
    outlined,
    ...rest
  } = props;

  const buttonDisabled = disabled === true || loading === true;

  return (
    <ComponentWrapperHOC
      wrap={!!href}
      wrapper={(children) => (
        <Link
          to={href!}
          target={target ?? "_self"}
          rel="noopener noreferrer"
          className="no-underline"
        >
          {children}
        </Link>
      )}
    >
      <button
        disabled={buttonDisabled}
        className={[
          s.button,
          s[color || "blue"],
          outlined && s.outlined,
          s[size ?? "medium"],
          className,
        ].join(" ")}
        onClick={buttonDisabled ? undefined : onClick}
        style={{ ...containerStyle }}
        {...rest}
      >
        {loading === true && <Loader color={color} />}
        {(loading === false || loading === undefined) && (
          <>
            {startIcon && startIcon}
            <span className={s.text} style={{ ...textStyle }}>
              {text}
            </span>
            {endIcon && endIcon}
          </>
        )}
      </button>
    </ComponentWrapperHOC>
  );
}
